import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/SpecialismsPage";
import { stripTags } from "@/functions/stripTags";
import sourceflowEnums from "@/sourceflow.enums";
import { getGlobal } from "@/functions/getGlobal";
import { router } from "@/router";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps() {
  const global = getGlobal();

  const routerProp = router["specialisms"];
  const titleKey = `page.specialisms.banner.title`;

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "SpecialismsPageBannerSection" },
        { component: "SpecialismsPageContentSection" },
        { component: "SpecialismsSection" },
        { component: "SpecialismsPageCountrySection" },
      ],
    },
  };
}
